import { GenericService } from '@/service/GenericService.ts';
import {
  CognitoUser,
  CognitoUserRepository,
} from '@/repository/CognitoUserRepository.ts';

export class CognitoUserService extends GenericService<CognitoUser> {
  protected repository: CognitoUserRepository;

  constructor() {
    const repo = new CognitoUserRepository();
    super(repo);
    this.repository = repo;
  }

  public override async search() {
    return await this.repository.search();
  }

  public async addUserToGroup(username: string, groupName: string) {
    return this.repository.addUserToGroup(username, groupName);
  }

  public async removeUserFromGroup(username: string, groupName: string) {
    return this.repository.removeUserFromGroup(username, groupName);
  }

  public async listGroups(username?: string) {
    return this.repository.listGroups(username);
  }
}
